import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { MdrDashboardsService } from '../../mdr-dashboards/services/mdr-dashboards.service';
import { OrganizationsService } from '../../organizations/services/organizations.service';
import { IdentityService } from '../services/identity.service';

@Injectable({
    providedIn: 'root',
})
class LcoOnlyGuardService {
    constructor(
        private mdrService: MdrDashboardsService,
        private identityService: IdentityService,
        private organizationService: OrganizationsService,
        private router: Router,
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const organization = this.organizationService.currentlySelectedOrganization() || this.identityService.company;
        /* Only LCO companies are allowed to see these routes */
        if (this.mdrService.isLcoCompany(organization)) {
            return of(true);
        } else {
            this.router.navigate(['/dashboard/browse']);
        }
        return of(false);
    }
}

export const LcoOnlyGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
    return inject(LcoOnlyGuardService).canActivate(next, state);
};
